import type { ReactNode } from 'react'

export type MultiSelectValue = Record<
  string,
  {
    checked: boolean
    label?: ReactNode
    textLabel?: string
    handleClear?: () => void
  }
>

export type Actions =
  | {
      type: ActionTypes.SetActions
      actions: ReactNode
    }
  | {
      type: ActionTypes.SelectOption
      value: MultiSelectValue
    }
  | {
      type: ActionTypes.UnselectOptions
      keys: string[]
    }

export enum ActionTypes {
  SetActions,
  SelectOption,
  UnselectOptions,
}
